export const exams = [
  "JEE",
  "NEET",
  "NDA",
  "KVPY",
  "NTSE",
  "CDS",
  "CLAT",
  "SSC",
  "UPSE-CSE",
  "GATE-IES",
  "CBSE-12",
  "CBSE-10",
  "CSIR",
  "IIT-JAM",
  "RRB",
];

export const state = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttarakhand",
  "Uttar Pradesh",
  "West Bengal",
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Delhi",
  "Lakshadweep",
  "Puducherry",
];
export const topics = [
  'Meditate',
  'Heat & Thermodynamics',
'Heat Transfer',
'Ray Optics',
'Fluids',
'Electromagnetic Waves',
'Nuclear Physics & X-Rays',
'Semiconductors',
'Work, Energy & Power',
'Error & Instrument Analysis',
'Units & Measurements',
'Gravitation',
'Dual Nature of Matter & Radiation',
'Wave Optics',
'Circular Motion',
'Photoelectric Effect',
'Center of Mass & Collisions',
'Oscillations',
'Communication Systems',
'Electromagnetic Induction & Alternating Current',
'Laws of Motion',
'Rotation',
'Kinematics',
'Electrostatics',
'Magnetic Effects of Current & Magnetism',
'Bohr Atomic Model',
'Waves & Sound',
'Atomic Structure',

'Chemical Equilibrium',

'Gaseous & Liquid State',

'Redox & Volumetric Analysis',

'Electrochemistry',

'Solutions',

'Chemical Kinetics',

'Metallurgy',

'Nuclear & Surface Chemistry',

'Qualitative Analysis',

'Chemical Bonding',

'Hydrocarbons',

'd-Block Elements',

'Mole Concept',

'Co-ordination Compound',

'Ionic Equilibrium',

'Alkyl Halides',

'Solid State',

'Aromatic Compounds',

's-Block Elements',

'Thermodynamics',

'Periodic Classification',

'p-Block Elements',

'Classification & Nomenclature',

'General Organic Chemistry',

'Alcohol & Ether',

'Isomerism',

'Nitrogen Compounds & Aliphatic Amines',

'Aldehydes and Ketones',

'Biomolecules & Polymers',

'Carboxylic Acids & Its Derivatives',
"3 Dimensional Geometry",
'Differential Equation',
'Vectors',

'Differentiation,',

'Determinant & Matrices',

'Trigonometric Equation',

'Sequence & Series',

'Statistics',

'Straight Line',

'Mathematical Logic',

'Circle',

'Set & Relation',

'Probability Distribution (Binomial + Mean & Variance)',

'Height & Distance',

'Definite Integral & Area Under the Curve',

'Trigonometric Ratio & Functions',
'Limits, Continuity & Differentiability',

'Properties of Triangle',

'Functions',

'Permutation & Combination',

'Application of Derivatives',

'Indefinite Integral',
'Conic Sections',
'Complex Number',

'Quadratic Equation',

'Binomial Theorem & M. I.',
];